import { createFileRoute } from '@tanstack/react-router';

import { staticPageHead } from '@/config/seo-head';
import { ContactPage } from '@/features/contact/contact-page';

export const Route = createFileRoute('/contact')({
  head: () => staticPageHead('/contact'),
  component: ContactPage,
});
